import React, {FC} from "react";
import TableWrapper from "../../../components/table/TableWrapper";
import {routes} from "../../../app/routes";
import {Button} from "primereact/button";
import {useNavigate} from "react-router-dom";
import {
    HotelDto,
    useFindHotelsQuery,
    useFindCitiesQuery
} from "../../../api/eventsStoreApi";
import hotelActionTemplate from "./Actions";
import {selectSettingState, setSettingData} from "../../../slices/settingsSlice";
import TextInput from "../../../components/form/TextInput";
import {useAppSelector} from "../../../app/hooks";
import {PrimeIcons} from "primereact/api";

const Hotels: FC<{}> = ({}) => {
    const navigate = useNavigate();
    const {hotelFilter} = useAppSelector(selectSettingState);
    const {isLoading: isCityLoading, data: cityData} = useFindCitiesQuery({page: 0, size: 10000, sort: ['name']});
    const cities = cityData?.content || [];
    const {isLoading, data} = useFindHotelsQuery({
        page: 0,
        size: 10000
    });

    const columns = [
        {field: "name", header: "Name", sortable: true},
        {
            field: "cityId",
            header: "City",
            body: (row: HotelDto) => <>{cities.find(city => city.id === row.cityId)?.name}</>,
            sortable: true
        },
        {
            field: "",
            header: "",
            body: hotelActionTemplate,
        },
    ];

    return (
        <>
            <TextInput
                id="hotelFilter"
                name="hotelFilter"
                label=""
                value={hotelFilter}
                setProperty={setSettingData}
                searchIcon
                placeholder="Search"
            />
            <TableWrapper
                header="Hotels"
                isLoading={isLoading || isCityLoading}
                data={data?.content}
                columns={columns}
                addButton={<Button onClick={() => navigate(routes.ADD)} label="Add" icon={PrimeIcons.PLUS}/>}
                globalFilter={hotelFilter}
                stateKey="hotels-list"
            />
        </>
    );
};

export default Hotels;
